import axios from 'axios';
import * as types from '../mutation-types';
import {performApiRequest} from '@/store/helpers/vuex-helpers';
import type {PaymentProfile} from '@/types/payment';

export interface PaymentProfilesState {
    loading: Record<string, boolean>,
    paymentProfiles: PaymentProfile[],
}

const state: PaymentProfilesState = {
    loading: {
        get: false,
        delete: false,
    },
    paymentProfiles: [],
};

const getters = {
    loading: (state: PaymentProfilesState) => state.loading,
    paymentProfiles: (state: PaymentProfilesState) => state.paymentProfiles,
};

const mutations = {
    [types.SET_PAYMENT_PROFILES_LOADING](state: PaymentProfilesState, loading: { subject: string, loading: boolean }) {
        state.loading[loading.subject] = loading.loading;
    },
    [types.SET_PAYMENT_PROFILES](state: PaymentProfilesState, paymentProfiles: PaymentProfile[]) {
        paymentProfiles = !paymentProfiles ? [] : paymentProfiles;
        paymentProfiles = !Array.isArray(paymentProfiles) ? [paymentProfiles] : paymentProfiles;

        state.paymentProfiles = paymentProfiles;
    },
};

const actions = {
    async fetchPaymentProfiles({commit}) {
        const responseData = await performApiRequest(commit, 'SET_PAYMENT_PROFILES_LOADING', 'get', () => axios.get('/v1/payment-profiles'));
        commit(types.SET_PAYMENT_PROFILES, responseData.paymentProfile);
    },

    async getPaymentProfile({commit}, paymentProfile: PaymentProfile | string) {
        const uuid = typeof paymentProfile === 'object' ? paymentProfile.uuid : paymentProfile;

        const responseData = await performApiRequest(commit, 'SET_PAYMENT_PROFILES_LOADING', 'get', () => axios.get(`/v1/payment-profiles/${uuid}`));

        return responseData.paymentProfile;
    },

    async deletePaymentProfile({commit}, paymentProfile: string | PaymentProfile) {
        const uuid = typeof paymentProfile === 'object' ? paymentProfile.uuid : paymentProfile;

        return await performApiRequest(commit, 'SET_PAYMENT_PROFILES_LOADING', 'delete', () => axios.delete(`/v1/payment-profiles/${uuid}`));
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
